import { render } from "./SystemMessage.vue?vue&type=template&id=fc3657ec&scoped=true"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"

import "./SystemMessage.vue?vue&type=style&index=0&id=fc3657ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc3657ec"

export default script